import React from "react";
import styled from "styled-components";
import { Container, Row, Col, Button } from "reactstrap";

const ErrorContainer = styled(Container)`
  padding-top: 8rem;
  min-height: 60vh;
  display: flex;
  align-items: center;
  justify-content: center;
`;

class ErrorBoundary extends React.Component {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error("[ErrorBoundary]", error, errorInfo?.componentStack);
  }

  handleReset = () => {
    this.setState({ hasError: false });
    window.location.href = "/";
  };

  render() {
    if (this.state.hasError) {
      return (
        <ErrorContainer className="text-center">
          <Row>
            <Col md="8" className="mx-auto">
              <h2>Something went wrong</h2>
              <p>We're sorry for the inconvenience. Please try again.</p>
              <Button color="info" className="btn-round" onClick={this.handleReset}>
                Go to Home Page
              </Button>
            </Col>
          </Row>
        </ErrorContainer>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
